import React, { lazy } from 'react';

import { Route, Routes } from 'react-router-dom';

const ArticleCategory = lazy(() => import('components/pages/ArticleCategory'));
const ArticleDetail = lazy(() => import('./components/pages/ArticleDetail'));
const Articles = lazy(() => import('./components/pages/Articles'));
const ArticleSearch = lazy(() => import('./components/pages/ArticleSearch'));
const ArticleTag = lazy(() => import('./components/pages/ArticleTag'));
const Reviews = lazy(() => import('./components/pages/Reviews'));
const ReviewDetail = lazy(() => import('./components/pages/ReviewDetail'));
// const Commerce = lazy(() => import('./components/pages/Commerce'));
const Company = lazy(() => import('./components/pages/Company'));
const Faq = lazy(() => import('./components/pages/Faq'));
const Guide = lazy(() => import('./components/pages/Guide'));
const PrivacyPolicy = lazy(() => import('./components/pages/PrivacyPolicy'));
const ResetPassword = lazy(() => import('./components/pages/ResetPassword'));
const OwnerInterviews = lazy(
  () => import('./components/pages/OwnerInterviews')
);
const OwnerInterviewDetail = lazy(
  () => import('./components/pages/OwnerInterviewDetail')
);
const SpotReviews = lazy(() => import('./components/pages/SpotReviews'));
const SearchSpot = lazy(() => import('./components/pages/SearchSpot'));
const Share = lazy(() => import('./components/pages/Share'));
const SpotDetail = lazy(() => import('./components/pages/SpotDetail'));
const SpotReserve = lazy(() => import('./components/pages/SpotReserve'));
const Top = lazy(() => import('./components/pages/Top'));
const Contact = lazy(() => import('./components/pages/Contact'));
const NewsList = lazy(() => import('./components/pages/NewsList'));
const NewsDetail = lazy(() => import('./components/pages/NewsDetail'));
const WithHeaderAndFooterLayout = lazy(
  () => import('./components/templates/WithHeaderAndFooterLayout')
);
const MyPageLayout = lazy(() => import('./components/templates/MyPageLayout'));
const MyPageToFacilityProvider = lazy(
  () => import('./components/pages/MyPageToFacilityProvider')
);
const MyPageDrivingLicense = lazy(
  () => import('./components/pages/MyPageDrivingLicense')
);
const MyPageFavorites = lazy(
  () => import('./components/pages/MyPageFavorites')
);
const MyPageManageSpots = lazy(
  () => import('./components/pages/MyPageManageSpots')
);
const MyPageInquiries = lazy(
  () => import('./components/pages/MyPageInquiries')
);
const MyPageNotificationSetting = lazy(
  () => import('./components/pages/MyPageNotificationSetting')
);
const MyPageProfile = lazy(() => import('./components/pages/MyPageProfile'));
const MyPageReserves = lazy(() => import('./components/pages/MyPageReserves'));
const MyPageTop = lazy(() => import('./components/pages/MyPageTop'));

const MyPageReserveDetail = lazy(
  () => import('./components/pages/MyPageReserveDetail')
);
const MyPageSpotDashboard = lazy(
  () => import('./components/pages/MyPageSpotDashboard')
);
const MyPageSpotInquiries = lazy(
  () => import('./components/pages/MyPageSpotInquiries')
);
const MyPageSpotReserves = lazy(
  () => import('./components/pages/MyPageSpotReserves')
);
const MyPageCreateSpot = lazy(
  () => import('./components/pages/MyPageCreateSpot')
);
const MyPageEditSpot = lazy(() => import('./components/pages/MyPageEditSpot'));
const MyPageBankAccount = lazy(
  () => import('./components/pages/MyPageBankAccount')
);
const MyPageSpotSales = lazy(
  () => import('./components/pages/MyPageSpotSales')
);
const Terms = lazy(() => import('./components/pages/TermsPage'));

const App: React.FC = () => (
  <Routes>
    <Route path='/' element={<WithHeaderAndFooterLayout />}>
      {/* トップページ */}
      <Route path='' element={<Top />} />
      {/* お知らせ一覧 */}
      <Route path='news' element={<NewsList />} />
      {/* お知らせ詳細 */}
      <Route path='news/:newsId' element={<NewsDetail />} />
      {/* ご利用案内 */}
      <Route path='guide' element={<Guide />} />
      {/* よくあるご質問 */}
      <Route path='faq' element={<Faq />} />
      {/* 利用規約 */}
      <Route path='terms' element={<Terms />} />
      {/* プライバシーポリシー */}
      <Route path='privacy-policy' element={<PrivacyPolicy />} />
      {/* NOTE: 特定商取引法に基づく表示の文言がきたらコメントアウト解除 */}
      {/* 特定商取引法に基づく表示 */}
      {/* <Route path='commerce' element={<Commerce />} /> */}
      {/* 会社情報 */}
      <Route path='company' element={<Company />} />
      {/* お問い合わせ */}
      <Route path='contact' element={<Contact />} />
      {/* オーナーインタビュー一覧 */}
      <Route path='interview' element={<OwnerInterviews />} />
      {/* オーナーインタビュー詳細 */}
      <Route path='interview/:id' element={<OwnerInterviewDetail />} />
      <Route path='reset-password' element={<ResetPassword />} />
      {/* レビュー */}
      <Route path='review' element={<Reviews />} />
      {/* スポット・アクティビティ検索 */}
      <Route path='search-spot' element={<SearchSpot />} />
      {/* 記事トップ */}
      <Route path='articles' element={<Articles />} />
      {/* ユーザー向け LP 系 */}
      <Route path='share' element={<Share />} />
      {/* レビュー一覧 */}
      <Route path='reviews' element={<Reviews />} />
      {/* レビュー詳細 */}
      <Route path='reviews/:reviewId' element={<ReviewDetail />} />
      {/* 記事一覧 by カテゴリー */}
      <Route path='articles/category/:name' element={<ArticleCategory />} />
      {/* 記事一覧 by タグ */}
      <Route path='articles/tag/:name' element={<ArticleTag />} />
      {/* 記事検索 */}
      <Route path='articles/search' element={<ArticleSearch />} />
      {/* 記事詳細 */}
      <Route path='article/:id' element={<ArticleDetail />} />
      {/* スポット・アクティビティ詳細 */}
      <Route path='spot/:spotId' element={<SpotDetail />} />
      {/* 商品購入確認 */}
      <Route path='spot/:spotId/purchase' element={<SpotReserve />} />
      {/* スポットのレビュー一覧 */}
      <Route path='spot/:spotId/reviews' element={<SpotReviews />} />
    </Route>
    <Route path='mypage' element={<MyPageLayout />}>
      {/* マイページトップ */}
      <Route path='' element={<MyPageTop />} />
      {/* マイページ通知設定 */}
      <Route
        path='notification-setting'
        element={<MyPageNotificationSetting />}
      />
      {/* マイページプロフィール */}
      <Route path='profile' element={<MyPageProfile />} />
      {/* マイページ免許証・営業許可証 */}
      <Route path='driving-license' element={<MyPageDrivingLicense />} />
      {/* マイページお気に入り */}
      <Route path='favorites' element={<MyPageFavorites />} />
      {/* 予約一覧 */}
      <Route path='reserves' element={<MyPageReserves />} />
      {/* お問い合わせ一覧 */}
      <Route path='inquiries' element={<MyPageInquiries />} />
      {/* 商品オーナー */}
      <Route path='spots'>
        {/* ダッシュボード */}
        <Route path='dashboard' element={<MyPageSpotDashboard />} />
        {/* マイページ施設オーナーになる */}
        <Route path='to-provider' element={<MyPageToFacilityProvider />} />
        {/* スポット一覧 */}
        <Route path='manage' element={<MyPageManageSpots />} />
        {/* お問い合わせ管理 */}
        <Route path='inquiries' element={<MyPageSpotInquiries />} />
        {/* 注文管理 */}
        <Route path='reserves' element={<MyPageSpotReserves />} />
        {/* マイページ商品作成 */}
        <Route path='new' element={<MyPageCreateSpot />} />
        {/* マイページ商品編集 */}
        <Route path='edit/:spotId' element={<MyPageEditSpot />} />
        {/* 口座情報管理 */}
        <Route path='bank-account' element={<MyPageBankAccount />} />
        {/* 売上管理 */}
        <Route path='sales' element={<MyPageSpotSales />} />
      </Route>
      <Route path='reserves'>
        {/* 注文詳細 */}
        <Route path=':reserveId' element={<MyPageReserveDetail />} />
      </Route>
    </Route>
  </Routes>
);

export default App;
